import {
  getIdentityFullName,
  getRosterIdentityMainLinkedIdentity,
} from '../../../../../../util/identity';

/**
 * Maps RosterIdentity records to AlbumCustomPrint recipients.
 * Used in Address Book global Waldogram/Collage checkouts.
 *
 * @param {Array<Object>} [rosterIdentities] The RosterIdentity records.
 * @returns {{firstName: string, lastName: string, address: Object, identityId: string, fullName: string}[]}
 */
export const mapRosterIdentitiesToCustomPrintRecipients = (
  rosterIdentities = [],
) => {
  return rosterIdentities.map(rosterIdentity => {
    const mainLinkedIdentity = getRosterIdentityMainLinkedIdentity(
      rosterIdentity,
    );

    return {
      rosterIdentityId: rosterIdentity.id,
      accountId: mainLinkedIdentity?.account?.id,
      identityId: mainLinkedIdentity?.identity?.id,
      firstName: rosterIdentity.first_name,
      lastName: rosterIdentity.last_name,
      fullName: getIdentityFullName(rosterIdentity),
      address: mainLinkedIdentity?.addresses?.records?.[0],
    };
  });
};
